import React, { useEffect, useState } from 'react'
import { CFormTextarea, CCard, CButton, CSpinner, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CCardBody, CFormInput, CFormLabel, CForm, CRow, CCol, CBadge } from '@coreui/react'
import fetchPatientData from '../../services/general/patientGeneralAPI.api'
import Carder from '../../components/shared/Carder'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import Graytextarea from '../../components/Graytextarea'
import GraytextareaAdjustable from '../../components/GrayTextareaAdjustable'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const PatientVitals = ({ patientID, loading, setLoading, vitalsList, setVitalsList, noteStructureRef, saveTreatsShell }) => {
  const [textInput, setTextInput] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [activeTab, setActiveTab] = useState('new')
  const [currentDate, setCurrentDate] = useState('')
  const [editPatientVitalIdDate, setEditPatientVitalIdDate] = useState(null)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [editId, setEditId] = useState(null)
  const [editableVitalId, setEditableVitalId] = useState('')
  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  const [vitals, setVitals] = useState({
    BloodPressure: '',
    HeartRate: '',
    RespiratoryRate: '',
    Temperature: '',
    SpO2: '',
    InhaledO2: '',
    HeartCirc: '',
    remarks: '',
    Height: '',
    Weight: '',
  })

  const vitalFields = [
    { name: 'BloodPressure', label: 'Blood Pressure', unit: 'mmHg' },
    { name: 'HeartRate', label: 'Heart Rate', unit: 'bpm' },
    { name: 'RespiratoryRate', label: 'Respiratory Rate', unit: 'rpm' },
    { name: 'Temperature', label: 'Temperature', unit: '°F' },
    { name: 'SpO2', label: 'SpO2', unit: '%' },
    { name: 'InhaledO2', label: 'Inhaled O2', unit: '%' },
    { name: 'HeartCirc', label: 'Heart Circ', unit: 'in' },
    { name: 'Height', label: 'Height', unit: 'ft/in' },
    { name: 'Weight', label: 'Weight', unit: 'lbs/oz' },
  ]

  const getPatientVitals = async () => {
    let allVital = { PatientID: patientID }
    allVital = [allVital]
    let allData
    allData = await fetchPatientData('GET', 'Vitals', JSON.stringify(allVital))
    allData = JSON.parse(allData.d) || {}

    setVitalsList(allData?.Data)
    return allData?.Data
  }

  useEffect(() => {
    setCurrentDate(getFormattedDate())
    getPatientVitals()
  }, [patientID])

  const handleInputChange = (event) => {
    setTextInput(event.target.value)
  }

  const handleVitalChange = (e) => {
    const { name, value } = e.target
    setVitals((prevVitals) => ({
      ...prevVitals,
      [name]: value,
    }))
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}/${dd}/${yyyy} ${hh}:${min}`
  }

  // const handleAddVitals = async () => {
  //     // for (const [key, value] of Object.entries(vitals)) {
  //     //     if (['remarks', 'height', 'weight'].includes(key)) {
  //     //         continue;
  //     //     }
  //     //     if (!value) {
  //     //         toast.error('Please fill all the information', toastConfig)
  //     //         return;
  //     //     }
  //     // }
  //     const newVitals = {
  //         BloodPressure: vitals.BloodPressure,
  //         HeartRate: vitals.HeartRate,
  //         RespiratoryRate: vitals.RespiratoryRate,
  //         Temperature: vitals.Temperature,
  //         SpO2: vitals.SpO2,
  //         InhaledO2: vitals.InhaledO2,
  //         HeartCirc: vitals.HeartCirc,
  //         Remarks: vitals.remarks,
  //         Height: vitals.Height,
  //         Weight: vitals.Weight,
  //         Date: editPatientVitalIdDate || getFormattedDate(),
  //     };
  //     // Reset vitals state
  //     setVitals({
  //         BloodPressure: '',
  //         HeartRate: '',
  //         RespiratoryRate: '',
  //         Temperature: '',
  //         SpO2: '',
  //         InhaledO2: '',
  //         HeartCirc: '',
  //         remarks: '',
  //         Height: '',
  //         Weight: '',
  //     });

  //     // const storedVitalsKey = 'storedPatientVitals';
  //     // const storedVitals = JSON.parse(localStorage.getItem(storedVitalsKey)) || {};

  //     // if (!storedVitals[patientID]) {
  //     //     storedVitals[patientID] = [];
  //     // }

  //     // if (editId) {
  //     //     const existingVitalsIndex = storedVitals[patientID].findIndex(vital => vital.ID === editId);
  //     //     if (existingVitalsIndex !== -1) {
  //     //         storedVitals[patientID][existingVitalsIndex] = newVitals;
  //     //     } else {
  //     //         storedVitals[patientID].push(newVitals);
  //     //     }
  //     // } else {
  //     //     storedVitals[patientID].push(newVitals);
  //     // }

  //     // localStorage.setItem(storedVitalsKey, JSON.stringify(storedVitals));

  //     // setVitalsList(storedVitals[patientID]);
  //     setModalVisible(false);
  //     setEditPatientVitalIdDate(null);

  //     let allVital = {
  //         BloodPressure: vitals.BloodPressure,
  //         HeartRate: vitals.HeartRate,
  //         RespiratoryRate: vitals.RespiratoryRate,
  //         Temperature: vitals.Temperature,
  //         SpO2: vitals.SpO2,
  //         InhaledO2: vitals.InhaledO2,
  //         HeartCirc: vitals.HeartCirc,
  //         Remarks: vitals.remarks,
  //         Height: vitals.Height,
  //         Weight: vitals.Weight,
  //         Date: vitals.Date || getFormattedDate(),
  //         PatientID: patientID,
  //     };

  //     let allVitalArray = [allVital];
  //     if (editId) {
  //         await fetchPatientData("UPDATE", "Vitals", JSON.stringify(allVitalArray));
  //         setEditId(null)
  //         await getPatientVitals()
  //         toast.success("Successfully Updated", toastConfig)
  //     } else {
  //         await fetchPatientData("INSERT", "Vitals", JSON.stringify(allVitalArray));
  //         const allVitals = await getPatientVitals()
  //         if (allVitals.length > 0) {
  //             setEditableVitalId(allVitals[allVitals.length - 1]?.ID) // could be this
  //             noteStructureRef.current = {
  //                 ...noteStructureRef.current,
  //                 metadata: {
  //                     ...noteStructureRef.current.metadata,
  //                     vitalId: allVitals[allVitals.length - 1]?.ID
  //                 }
  //             }
  //             await saveTreatsShell(false)
  //         }
  //         toast.success("Successfully Added", toastConfig)
  //     }
  // };

  const handleAddVitals = async () => {
    // Build the final vitals object FIRST (before resetting state)
    const newVitals = {
      ID: editId || null,
      BloodPressure: vitals.BloodPressure,
      HeartRate: vitals.HeartRate,
      RespiratoryRate: vitals.RespiratoryRate,
      Temperature: vitals.Temperature,
      SpO2: vitals.SpO2,
      InhaledO2: vitals.InhaledO2,
      HeartCirc: vitals.HeartCirc,
      Remarks: vitals.remarks,
      Height: vitals.Height,
      Weight: vitals.Weight,
      Date: editPatientVitalIdDate || getFormattedDate(),
      PatientID: patientID,
    }

    // Close modal & clear edit
    setModalVisible(false)
    setEditId(null)
    setEditPatientVitalIdDate(null)

    // Build array for API
    const allVitalArray = [newVitals]

    if (editId) {
      // UPDATE FLOW
      await fetchPatientData('UPDATE', 'Vitals', JSON.stringify(allVitalArray))
      setEditId(null)
      await getPatientVitals()
      toast.success('Successfully Updated', toastConfig)
    } else {
      // INSERT FLOW
      await fetchPatientData('INSERT', 'Vitals', JSON.stringify(allVitalArray))
      const allVitals = await getPatientVitals()

      if (allVitals.length > 0) {
        const latestId = allVitals[allVitals.length - 1].ID

        //setEditableVitalId(latestId);

        // attach vitalId to note metadata
        noteStructureRef.current = {
          ...noteStructureRef.current,
          metadata: {
            ...noteStructureRef.current.metadata,
            vitalId: latestId,
          },
        }

        await saveTreatsShell(false)
      }

      toast.success('Successfully Added', toastConfig)
    }

    setVitals({
      BloodPressure: '',
      HeartRate: '',
      RespiratoryRate: '',
      Temperature: '',
      SpO2: '',
      InhaledO2: '',
      HeartCirc: '',
      remarks: '',
      Height: '',
      Weight: '',
    })
    setEditId(null)
    setEditPatientVitalIdDate(null)
  }
  const handleEditPatientVitals = (selectedVitals) => {
    setEditPatientVitalIdDate(selectedVitals.Date)
    setEditId(selectedVitals.ID)
    setModalVisible(true)

    setVitals({
      id: selectedVitals.ID || '',
      BloodPressure: selectedVitals.BloodPressure || '',
      HeartRate: selectedVitals.HeartRate || '',
      RespiratoryRate: selectedVitals.RespiratoryRate || '',
      Temperature: selectedVitals.Temperature || '',
      SpO2: selectedVitals.SpO2 || '',
      InhaledO2: selectedVitals.InhaledO2 || '',
      HeartCirc: selectedVitals.HeartCirc || '',
      remarks: selectedVitals.Remarks || '',
      Height: selectedVitals.Height || '',
      Weight: selectedVitals.Weight || '',
    })
  }

  const handleDeletePatientVital = async () => {
    await fetchPatientData('DELETE', 'Vitals', JSON.stringify({ ID: deleteVisibleId?.toString() }))
    getPatientVitals()
    setDeleteVisibleId(null)
    setEditableVitalId('')
  }

  // useEffect(() => {
  //     const vitalEditId = noteStructureRef?.current?.metadata?.vitalId
  //     if (vitalEditId) {
  //         setEditableVitalId(vitalEditId)
  //     }
  // }, [])

  const handleAddVital = () => {
    setEditId(null)
    setEditPatientVitalIdDate(null)
    setVitals({
      BloodPressure: '',
      HeartRate: '',
      RespiratoryRate: '',
      Temperature: '',
      SpO2: '',
      InhaledO2: '',
      HeartCirc: '',
      remarks: '',
      Height: '',
      Weight: '',
    })
    setModalVisible(true)
  }
  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
          <CSpinner color="primary" />
        </div>
      ) : (
        <>
          {/* delete modal */}
          <CModal visible={deleteVisibleId}>
            <CModalHeader>
              <CModalTitle>Warning</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
            </CModalBody>
            <hr className="p-0 m-0" />
            <CModalFooter className="p-3 m-0">
              <CButton
                onClick={() => {
                  setDeleteVisibleId(null)
                }}
                className="text-white"
                color="secondary"
              >
                Close
              </CButton>
              <CButton onClick={handleDeletePatientVital} className="text-white" color="danger">
                Delete
              </CButton>
            </CModalFooter>
          </CModal>

          <CButton
            style={{ marginTop: '10px' }}
            onClick={handleAddVital}
            variant="outline"
            color="primary"
            className="patient-page-action-btn"
          >
            + Add Vitals
          </CButton>

          {vitalsList?.length > 0 &&
            vitalsList
              .slice()
              .reverse()
              .map((vital, index) => {
                const isLinked = noteStructureRef?.current?.metadata?.vitalId && noteStructureRef.current.metadata.vitalId === vital.ID
                const displayDate = vital.Date || vital.date || ''
                return (
                  <Carder
                    editFunc={() => handleEditPatientVitals(vital)}
                    deleteFunc={() => setDeleteVisibleId(vital.ID)}
                    title={`Date : ${displayDate}`}
                    key={index}
                  >
                    <CRow className="p-4">
                      <CCol md="6">
                        {vitalFields.slice(0, Math.ceil(vitalFields.length / 2)).map(
                          (field, idx) =>
                            vital[field.name] && (
                              <div key={idx} className="mb-2">
                                <strong>{field.label}:</strong> {vital[field.name]} {field.unit}
                              </div>
                            ),
                        )}
                      </CCol>
                      <CCol md="6">
                        {vitalFields.slice(Math.ceil(vitalFields.length / 2)).map(
                          (field, idx) =>
                            vital[field.name] && (
                              <div key={idx} className="mb-2">
                                <strong>{field.label}:</strong> {vital[field.name]} {field.unit}
                              </div>
                            ),
                        )}
                      </CCol>
                      {vital.Remarks && (
                        <div className="mb-2" style={{ whiteSpace: 'pre-line' }}>
                          <strong>Remarks:</strong> {vital.Remarks}
                        </div>
                      )}
                      {/* {isLinked && (
                        <div className="mt-2"><CBadge color="info">Linked</CBadge></div>
                      )} */}
                    </CRow>
                  </Carder>
                )
              })}

          {noteStructureRef?.current?.freeTypesEverything?.vitalsFreetype && (
            <>
              <hr className="hr-text" data-content="Old Vital" />
              <div className="mt-2">
                <div
                  className="p-4 patient-theme-old-data patient-theme-old-data--readonly"
                  onClick={(e) => {
                    setTempHtmlContent(noteStructureRef?.current?.freeTypesEverything?.vitalsFreetype || '')
                    // setShowEditHtml(true)
                  }}
                  dangerouslySetInnerHTML={{ __html: noteStructureRef?.current?.freeTypesEverything?.vitalsFreetype }}
                ></div>
              </div>
            </>
          )}
        </>
      )}

      <CModal className="dashboard-dark-modal patient-theme-modal patient-labs-modal patient-vitals-modal" backdrop="static" size="lg" scrollable visible={modalVisible} onClose={() => setModalVisible(false)}>
        <CModalHeader onClose={() => setModalVisible(false)}>
          <CModalTitle>Add Patient Vitals</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CForm>
            <CRow className="mb-3">
              <CCol xs="6">
                <CFormLabel>Recorded Date and Time</CFormLabel>
                <CFormInput type="text" value={getFormattedDate()} disabled />
              </CCol>
              <CCol xs="6">
                <CFormLabel>Recorded By</CFormLabel>
                <CFormInput type="text" value="Admin" disabled />
              </CCol>
            </CRow>
            <CRow>
              {vitalFields.map((field, index) => (
                <CCol xs="6" key={index} className="mb-3">
                  <CFormLabel>{field.label}</CFormLabel>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <CFormInput type="text" name={field.name} value={vitals[field.name]} onChange={handleVitalChange} style={{ flex: '4' }} />
                    <CFormInput
                      type="text"
                      value={field.unit}
                      disabled
                      style={{
                        flex: '1',
                        backgroundColor: '#e9ecef',
                        borderColor: '#ced4da',
                        textAlign: 'center',
                      }}
                    />
                  </div>
                </CCol>
              ))}
            </CRow>
            <CRow className="mb-3">
              <CCol xs="12">
                <CFormLabel>Remarks</CFormLabel>
                <GraytextareaAdjustable
                  name="remarks"
                  value={vitals.remarks}
                  onChange={handleVitalChange}
                  rows="1"
                  style={{ minHeight: '40px' }}
                />
              </CCol>
            </CRow>
          </CForm>
        </CModalBody>
        <CModalFooter>
          <CButton 
            onClick={handleAddVitals}
            style={{ backgroundColor: 'var(--ui-color-primary, #2b7cd3)', borderColor: 'var(--ui-color-primary, #2b7cd3)', color: '#fff' }}
          >
            {editId ? 'Update Vitals' : 'Add Vitals'}
          </CButton>
          <CButton color="secondary" variant="outline" onClick={() => setModalVisible(false)}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Vitals Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  vitalsFreetype: tempHtmlContent,
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
              setTempHtmlContent('')
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientVitals
